<template>
  <Takeover active class="takeover-container">
    <CheckoutHeader />
    <CheckoutContent />
    <UniversalModal />
  </Takeover>
</template>
<script setup lang="ts">
import { onMounted } from 'vue'
import Takeover from '@/components/shared/Takeover.vue'
import CheckoutHeader from '@/components/shared/header/CheckoutHeader.vue'
import CheckoutContent from '@/components/shared/CheckoutContent.vue'
import UniversalModal from '@/components/shared/UniversalModal.vue'
import { useHotKeyStore } from '@/store/HotKeyStore'
import { storeToRefs } from 'pinia'
import { useHead } from '@unhead/vue'
import { useProductStore } from '@/store/ProductStore'
import { useAmplitude } from '@outputinc/o-analytics'
import { useOfferStore } from '@/store/OfferStore'

const { track, Events } = useAmplitude()
const offerStore = useOfferStore()
const { activeOfferId } = storeToRefs(offerStore)
const { keyUpEventListener } = useHotKeyStore()

const productStore = useProductStore()
const { productName } = storeToRefs(productStore)

useHead({
  title: () => `Get ${productName.value} - Output`
})

onMounted(() => {
  eventListeners()
  track(Events.CHECKOUT_SUBSCRIPTION_OFFER_VIEW, {
    offerId: activeOfferId.value
  })
})

const eventListeners = () => {
  window.addEventListener('keyup', event => keyUpEventListener(event), false)
}
</script>

<style scoped lang="scss">
.takeover-container {
  overflow: scroll;
  scrollbar-width: none;
}
</style>
